/** @format */

export function complete() {
  return this.steps.findIndex((step) => step.name == this.state.name) + 1 == this.steps.length;
}
